var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-chip-flat-pill', _vm._b({
    attrs: {
      "color": "#E3F2FD",
      "text-color": "#2196F3"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (_, slotName) {
      return {
        key: slotName,
        fn: function () {
          return [_vm._t(slotName)];
        },
        proxy: true
      };
    })], null, true)
  }, 'u-chip-flat-pill', _vm.$attrs, false));

}
var staticRenderFns = []

export { render, staticRenderFns }